import React from "react";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import {GroupRecord, PermissionRecord} from "../../../feathers/records";
import GroupModal from "../../../components/GroupModal";
import GroupListItem from "./GroupListItem";
import style from "./style.js";

export default class Groups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentlyEditing: null,
      currentTotal: 0
    };
  }

  componentDidMount() {
    PermissionRecord.find();
  }

  handleOpenModal = (group, totalCount) => {
    this.setState({currentTotal: totalCount, currentlyEditing: group});
  };

  handleCloseModal = () => {
    this.setState({currentlyEditing: null});
  };

  concatGroups(permissions) {
    let groups = [];
    if (!permissions) {
      return groups;
    }
    permissions.toList().forEach(permission => {
      groups = groups.concat(permission.permissions.groups);
    });
    return groups;
  }

  renderGroups(groups) {
    if (groups.size <= 0) {
      return null;
    }

    const {permissions, invitations, disabled} = this.props;
    let permissionGroups = this.concatGroups(permissions);
    let invitationGroups = this.concatGroups(invitations);

    return (
      <List style={style.groupList}>
        {groups.toList().map(group => {
          return (
            <React.Fragment key={group._id}>
              <GroupListItem
                permissionGroups={permissionGroups}
                invitationGroups={invitationGroups}
                group={group}
                disabled={disabled}
                onOpenModal={this.handleOpenModal}
              />
              <Divider />
            </React.Fragment>
          );
        })}
      </List>
    );
  }

  render() {
    const {groups, disabled} = this.props;
    const {currentlyEditing, fetching} = this.state;
    const groupLabel = `${groups.size} group${groups.size === 1 ? "" : "s"}`;

    return (
      <div className="margin-bottom-30">
        {currentlyEditing && (
          <GroupModal
            group={currentlyEditing}
            onRequestClose={this.handleCloseModal}
            totalCount={this.state.currentTotal}
          />
        )}
        <Paper className="col-sm-7">
          <div className="container-paper">
            <div className="row">
              <div className="col-sm-6 col-xs-12">
                <p className="text-muted">{groupLabel}</p>
              </div>
              <div className="col-sm-6 margin-bottom-15">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.handleOpenModal(new GroupRecord(), 0)}
                  disabled={disabled}>
                  New group
                </Button>
              </div>
            </div>
            {this.renderGroups(groups)}
          </div>
        </Paper>
        {fetching && <LinearProgress mode="indeterminate" />}
      </div>
    );
  }
}

Groups.propTypes = {
  groups: PropTypes.object,
  permissions: PropTypes.object,
  invitations: PropTypes.object,
  disabled: PropTypes.bool
};

Groups.defaultProps = {
  disabled: false
};



// WEBPACK FOOTER //
// ./src/pages/Account/Groups/index.js